import React from 'react';
import { useLocation } from 'react-router-dom';

import { Scan } from '../components/Scan/Scan';
import { useTranslations } from '../components/Translations/TranslationsProvider';

export const ScanPage = () => {
    const { key } = useLocation();

    const { translations } = useTranslations();

    if (!translations) {
        return null;
    }

    return <Scan key={key} translations={translations} />;
};
